import * as React from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Loading } from "../../../../../../../react-components/lu-component/src/index";
import { adCopyV3Endpoint } from "../../../../../../../server/router/ad-copy/endpoint";
import { replaceEndpointUrl } from "../../../../../../../server/router/endpoint";
import type { AdCopyResultDetailsResBody } from "../../../../../../../server/types/request/ad-copy/report/resultDetails";
import { AdCopyRetestMenu } from "../../../../../components/pages/ad-copy/report/common";
import { AdCopyReportBigTitle } from "../../../../../components/pages/ad-copy/report/parts/report-title";
import { AdCopyResultByTargeReportPage } from "../../../../../components/pages/ad-copy/report/result-by-target";
import { ConfirmBox } from "../../../../../components/parts/confirm-box";
import { get, makeError } from "../../../../../lib/request";
import { initState, reducer } from "../../../../../reducers/ad-copy/report/result-by-target";
import { adCopyClientEndpoint } from "../../../../../routes/adCopyEndpoint";

export const AdCopyResultByTargetReportContainer = () => {
	const navigate = useNavigate();

	const [state, dispatch] = React.useReducer(reducer, initState);

	const { activity, data, simulationSummary, info, job, loading } = state;

	const { activityId, jobId } = useParams<{
		activityId: string;
		jobId: string;
	}>();

	React.useEffect(() => {
		get<AdCopyResultDetailsResBody>(`${adCopyV3Endpoint.resultDetails}/${jobId}`)
			.then((response) => {
				dispatch({ payload: response.data, type: "loadData" });
			})
			.catch((error) => {
				dispatch({ payload: makeError(error), type: "changeMessageInfo" });
			});
	}, [jobId]);

	const navigateSimulationPage = React.useCallback(() => {
		if (activityId == null || jobId == null) {
			return;
		}

		navigate(
			replaceEndpointUrl(adCopyClientEndpoint.simulationReportLatest, {
				activityId,
				jobId,
			}),
		);
	}, [activityId, jobId, navigate]);

	return (
		<>
			<Loading loading={loading} />

			{job && job.retestJobId && (
				<AdCopyRetestMenu activityId={activityId ?? ""} jobId={job.retestJobId.toString()} page="result-by-target" />
			)}

			<ConfirmBox info={info} titleLabel="コピー" />

			<AdCopyReportBigTitle>結果の詳細{job ? `（${job.jobNum}）` : ""}</AdCopyReportBigTitle>

			{activity && data && job && (
				<AdCopyResultByTargeReportPage
					activity={activity}
					data={data}
					dispatch={dispatch}
					simulationSummary={simulationSummary}
					job={job}
					navigateSimulationPage={navigateSimulationPage}
				/>
			)}
		</>
	);
};
